import { VisualInspectionDto, VisualInspectionReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type VisualInspectionDtoAny = VisualInspectionDto | VisualInspectionReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type VisualInspectionDtoAll = VisualInspectionDto & VisualInspectionReferenceDto;

export class VisualInspectionMapper {}
